import './PhoneAppFooter.css';
import * as React from "react";
import PropTypes from "prop-types";

PhoneAppFooter.propTypes = {
    onNext: PropTypes.func.isRequired,
    send: PropTypes.bool,
    enableNext: PropTypes.bool,
    enableIgnore: PropTypes.bool,
    last: PropTypes.bool,
}

export default function PhoneAppFooter(props) {
    const handleNextButton = (e) => {
        e.preventDefault();
        if (!props.onNext) {
            console.error("No onNext action on the footer but the button exists");
            return;
        }
        if (props.enableNext || props.enableIgnore || props.last || props.send) {
            props.onNext();
        }
    }

    let next = null;
    let text = "Doorgaan";
    if (props.send) {
        text = "Verstuur aanvraag";
    } else if (props.last) {
        text = "Opnieuw invullen";
    }
    if (props.onNext) {
        if (props.enableNext) {
            next = <button id="next-button" onClick={handleNextButton}>{text}</button>;
        } else {
            if (props.enableIgnore){
                next = <button id="next-button" className="warning" onClick={handleNextButton}>Advies overslaan</button>;
            } else {
                next = <button id="next-button" onClick={handleNextButton} disabled={true}>{text}</button>;
            }
        }
    }

    return (
        <footer className="phone-app-footer">
            {next}
        </footer>
    );
}
